import React from "react";

interface props {
  className?: string;
}

export const EditPageAndPencilIcon = ({ className }: props) => (
  <svg
    width="27"
    height="24"
    viewBox="0 0 27 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M19.5938 14.8125L20.5312 13.875C20.625 13.7812 20.7188 13.7656 20.8125 13.8281C20.9375 13.8594 21 13.9375 21 14.0625V21.75C21 22.375 20.7812 22.9062 20.3438 23.3438C19.9062 23.7812 19.375 24 18.75 24H2.25C1.625 24 1.09375 23.7812 0.65625 23.3438C0.21875 22.9062 0 22.375 0 21.75V5.25C0 4.625 0.21875 4.09375 0.65625 3.65625C1.09375 3.21875 1.625 3 2.25 3H15.9375C16.0625 3 16.1406 3.0625 16.1719 3.1875C16.2344 3.28125 16.2188 3.375 16.125 3.46875L15.1875 4.40625C15.1562 4.46875 15.0938 4.5 15 4.5H2.25C2.03125 4.5 1.84375 4.57813 1.6875 4.73438C1.5625 4.85938 1.5 5.03125 1.5 5.25V21.75C1.5 21.9688 1.5625 22.1406 1.6875 22.2656C1.84375 22.4219 2.03125 22.5 2.25 22.5H18.75C18.9688 22.5 19.1406 22.4219 19.2656 22.2656C19.4219 22.1406 19.5 21.9688 19.5 21.75V15C19.5 14.9062 19.5312 14.8438 19.5938 14.8125ZM26.4375 5.8125L11.7656 20.4844L7.07812 21C6.76562 21.0312 6.5 20.9375 6.28125 20.7188C6.0625 20.5 5.96875 20.2344 6 19.9219L6.51562 15.2344L21.1875 0.5625C21.5625 0.1875 22.0156 0 22.5469 0C23.1094 0 23.5781 0.1875 23.9531 0.5625L26.4375 3.04688C26.8125 3.42188 27 3.89062 27 4.45312C27 4.98437 26.8125 5.4375 26.4375 5.8125ZM22.0312 8.10938L18.8906 4.96875L7.96875 15.9375L7.59375 19.4531L11.1094 19.0312L22.0312 8.10938ZM25.3594 4.125L22.875 1.64062C22.6562 1.42187 22.4375 1.42187 22.2188 1.64062L19.9688 3.89062L23.1094 7.03125L25.3594 4.78125C25.5781 4.5625 25.5781 4.34375 25.3594 4.125Z"
      fill="black"
    />
  </svg>
);

EditPageAndPencilIcon.defaultProps = {
  className: "",
};
